import styled from "styled-components";

export const AddDocumentContainer = styled.main`
	background: #fff;
	min-height: 75vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const AddItemsContainer = styled.section`
	padding: 25px 23px;
	padding-bottom: 0px;
	background-color: #fff;
	position: relative;
	.ant-collapse {
		background-color: #fff;
	}

	.ant-collapse-item {
		margin-bottom: 16px;
	}

	.ant-collapse-header {
		background-color: #f2f6fa;
		font-weight: bold;
	}

	.ant-collapse-header-text {
		color: #2e333e;
		font-size: 16px; 
	}

	.ant-collapse-content-box {
		background-color: #fff;
		margin-top: 15px;
	}

	.ant-select-selection-placeholder {
		color: #2e333e;
	}

	#ec-status-container .passive .ant-select-selection-item {
		color: #ff4e4e;
		font-weight: bold;
	}

	#ec-status-container .active .ant-select-selection-item {
		color: #5fbe2d;
		font-weight: bold;
	}
`;


export const ActionButtonComponent = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
	padding: 0 0 23px 0;
`;

export const panelStyle: React.CSSProperties = {
	border: "none",
};